import {
  createAsyncThunk,
  ThunkDispatch,
  UnknownAction,
} from "@reduxjs/toolkit";
import { State } from "../state/state";
import { getOrganizationId } from "../selectors";
import { RequestParams } from "@/data/types";

type AsyncThunkConfig = {
  state?: unknown;
  dispatch?: ThunkDispatch<unknown, unknown, UnknownAction>;
  extra?: unknown;
  rejectValue?: unknown;
  serializedErrorType?: unknown;
  pendingMeta?: unknown;
  fulfilledMeta?: unknown;
  rejectedMeta?: unknown;
};

export function withOrgId<
  TParams extends Record<string, any> | undefined = RequestParams
>(
  getState: () => State,
  params: TParams = {} as TParams
): TParams & { organization_id?: string } {
  return {
    ...params,
    organization_id: getOrganizationId(getState()) ?? undefined,
  };
}

export function createTypedAsyncThunk<
  TReturn,
  TPayload = void,
  TThunkConfig extends AsyncThunkConfig = {}
>(
  typePrefix: string,
  payloadCreator: (payload: TPayload, thunkAPI: any) => Promise<unknown>
) {
  return createAsyncThunk<TReturn, TPayload, TThunkConfig>(
    typePrefix,
    payloadCreator as any
  );
}
